<template>
  <main-layout>

    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-24"></menubar>
    </div>

    <!--  ヘッダー行  -->
    <el-row slot="header">
      <head-title class="cancel-width">
          <label slot="title">{{ $t("label.system.userArea.tenant") }}</label>
          <sp-smart-button @click="backToBack" slot="cancel">{{ $t("button.common.data.cancel") }}</sp-smart-button>
          <!-- No.35 -->
          <narrow-down @click="saveUserArea" slot="create">{{ $t("button.common.data.create") }}</narrow-down>
      </head-title>
    </el-row>

    <div slot="body">
      <!-- subtitle -->
      <div class="main-title" style="margin-top:0px;">
        {{ $t("label.system.userArea.userEdit") }}
      </div>

      <el-row class="m-bottom-3">
          <div class="tenant-title">
            <span class="color">{{
              $t("label.system.userArea.tenantId")
            }}</span>
          </div>
          <div class="tenant">
            <span class="color">{{ tenantExId }}</span>
          </div>
      </el-row>
      <el-row style="margin-bottom:60px">
        <div class="tenant-title">
          <span class="color">{{
            $t("label.system.userArea.tenantName")
          }}</span>
        </div>
        <div class="tenant">
            <span class="color">{{ tenantName }}</span>
        </div>
      </el-row>

      <div class="radio-type">
        <span class="editorialObject-type">
          {{$t("label.system.userGroup.search.editorialObject")}}
        </span>

        <el-radio  v-model="radio" label="1">{{$t("label.system.userGroup.search.user")}}</el-radio>
        <el-radio v-model="radio" label="2">{{$t("label.system.userGroup.search.userGroup")}}</el-radio>
      </div>

      <el-table
        :cell-style="userChangeCellStyle"
        ref="table1"
        v-show="radio == '1' "
        id="search-result"
        height="470"
        :class="tenantRelatedAreaList.length > 8 ?'margan-button-40  table-type-user-area-edit': 'margan-button-40 table-type table-type-user-area-edit'"
        :data="userAreaResult.accountList">
        <el-table-column
          width="200px"
          :label="$t('label.system.userGroup.search.allChoice')"
        >
          <el-table-column
          width="200px"
          prop="fullname"
          :label="$t('label.system.userGroup.search.userName')"
          >
          <template slot-scope="scope">
            <div :class="tenantRelatedAreaList.length > 0 ? 'fullname-type' :'fullname-type-noData'">
              <span>
                {{ scope.row.fullname }}
              </span>
            </div>
          </template>
          </el-table-column>
        </el-table-column>

        <template v-for="(item, index) in tenantRelatedAreaList">
          <el-table-column
            align="center"
            class-name="el-table-two"
            :render-header="renderHeader"
            :key="index">
            <el-table-column
              :width="tableColumnWidth"
              align="center"
              :key="index">
              <template slot="header">
                <div class="place-type">
                  {{item.buildingName + item.floorName}}
                </div>
                <div class="place-type">
                  {{item.areaName}}
                </div>
              </template>
              <template  slot-scope="scope">
                <el-checkbox
                  :style="{ width: tableColumnWidth }"
                  v-model="scope.row[item.prop]"
                  :scope="scope"
                  @change="cellChange(item.prop, scope.$index, scope.column)"
                ></el-checkbox>
              </template>
            </el-table-column>
          </el-table-column>
        </template>
        <el-table-column
          label="">
        </el-table-column>
      </el-table>

      <el-table
        :cell-style="userGroupChangeCellStyle"
        ref="table2"
        v-show="radio == '2' "
        id="search-result"
        height="470"
        :class="tenantRelatedAreaList.length > 8 ?'margan-button-40  table-type-user-area-edit': 'margan-button-40 table-type table-type-user-area-edit'"
        :data="userAreaResult.userGroupList">
        <el-table-column
          width="200px"
          :label="$t('label.system.userGroup.search.allChoice')"
        >
          <el-table-column
          width="200px"
          prop="fullname"
          :label="$t('label.system.userGroup.search.userGroupName')"
          >
          <template slot-scope="scope">
            <div :class="tenantRelatedAreaList.length > 0 ? 'fullname-type' :'fullname-type-noData'">
              <span>
                {{ scope.row.userGroupName }}
              </span>
            </div>
          </template>
          </el-table-column>
        </el-table-column>

        <template v-for="(item, index) in tenantRelatedAreaList">
          <el-table-column
            align="center"
            class-name="el-table-two"
            :render-header="renderHeaderUserGroup"
            :key="index">
            <el-table-column
              align="center"
              :width="tableColumnWidth"
              :key="index">
              <template slot="header">
                <div class="place-type">
                  {{item.buildingName + item.floorName}}
                </div>
                <div class="place-type">
                  {{item.areaName}}
                </div>
              </template>
              <template slot-scope="scope">
                <el-checkbox
                  :style="{ width: tableColumnWidth }"
                  ref="checkbox"
                  v-model="scope.row[item.prop]"
                  :scope="scope"
                  @change="cellChangeUserGroup(item.prop, scope.$index, scope.column)"
                ></el-checkbox>
              </template>
            </el-table-column>
          </el-table-column>
        </template>
        <el-table-column
          label="">
        </el-table-column>
      </el-table>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>

      <loading-dialog :dialogVisible="showLoading" />

    </div>
  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import SystemManageApi from "@/api/SystemManageApi";
import headTitle from "@/components/common/head/head"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import SpSmartButton from "@/components/common/sp-smart-button"
import NewDesignLayout from "@/layout/NewDesignLayout";
import Menubar from "@/components/leftmenu/DashBoard";
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import elDialogPrompt from "@/components/common/el-dialog-prompt";
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;

export default {
  name: "UserAreaEdit",
  components: {
    headTitle:headTitle,
    LoadingDialog: LoadingDialog,
    narrowDown:narrowDown,
    SpSmartButton:SpSmartButton,
    MainLayout: NewDesignLayout,
    Menubar,
    elDialogPrompt
  },
  data: function () {
    return {
      tableWidth:null,
      tableColumnWidth:null,
      radio:"1",
      msgParam: this.$t("message.common.validation.saveMessage",{
        field:"ユーザーエリア"
      }),
      showLoading: false,
      centerDialogVisibleIsShow: false,
      pageSize: DEFAULT_PAGE_SIZE,
      pageNumber: DEFAULT_PAGE_NUMBER,
      totalPage: 0,
      totalCount: 0,
      checkAll: false,
      relatedAreaIds: false,
      userAreaResult: {
        accountList: [],
        userGroupList: []
      },
      tenantRelatedAreaList: [],
      accountList: [
        {
          id: null,
          relatedAreaIds: [],
        },
      ],
      tenantId: null,
      tenantName: null,
      tenantExId: null,
    };
  },
  watch:{
    tableWidth(val) {
      this.tableColumnWidth = parseInt((val-200)/8-2) + 'px'
    }
  },
  methods: {
    userChangeCellStyle (row) {
      if(row.column.label === "ユーザー名"){
          return 'position: sticky;left:0px;background: #F2F2ED;z-index: 99'
      }else{
          return ''
      }
    },

    userGroupChangeCellStyle (row) {
      if(row.column.label === "ユーザーグループ名"){
          return 'position: sticky;left:0px;background: #F2F2ED;z-index: 99'
      }else{
          return ''
      }
    },
    backToBack() {
      this.$router.go(-1);
    },

    // テナント利用者関連エリアリスト情報検索兼エリアマスタ取得
    searchAccountAreaRelation() {
      this.showTableLoadingAnim()
      SystemManageApi.searchAccountAreaRelation(
        this.tenantId
      ).catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          return;
        }
        this.userAreaResult.accountList = data.body.accountList;
        this.userAreaResult.userGroupList = data.body.userGroupList;
        this.tenantRelatedAreaList = data.body.tenantRelatedAreaList
        this.tenantRelatedAreaList.map((item) => {
          item.prop = item.areaId;
          item.colCheck = false;
          this.userAreaResult.accountList.map((items) => {
            items[item.prop] = false
            items.checked = false
            items.relatedAreaIds.map((ele) => {
                if(item.prop == ele){
                  items[item.prop] = true
                }
            })
          })
          this.userAreaResult.userGroupList.map((items) => {
            items[item.prop] = false
            items.checked = false
            items.relatedAreaIds.map((ele) => {
                if(item.prop == ele){
                  items[item.prop] = true
                }
            })
          })
        });
      }).finally(() => {
        this.hideTableLoadingAnim()
      })
    },
    renderHeader(h, { column, $index }) {
      let index = $index;
      return h("div", [
        h("el-checkbox", {
          props: {
            value: this.tenantRelatedAreaList[index - 1].colCheck,
          },
          on: {
            change: ($event) => {
              this.select($event, index);
            },
          },
        }),
        h("span", column.label),
      ]);
    },
    renderHeaderUserGroup(h, { column, $index }) {
      let index = $index;
      return h("div", [
        h("el-checkbox", {
          props: {
            value: this.tenantRelatedAreaList[index - 1].colCheck,
          },
          on: {
            change: ($event) => {
              this.selectUserGroup($event, index);
            },
          },
        }),
        h("span", column.label),
      ]);
    },
    selectUserGroup(obj, index) {
      const objs = this.tenantRelatedAreaList[index - 1].prop;
      if (obj) {
        this.tenantRelatedAreaList[index - 1].colCheck = true;
        this.userAreaResult.userGroupList.map((item) => {
          for (let key in item) {
            if (key == objs) {
              item[key] = true;
            }
          }
        });
        for (let i = 0; i < this.userAreaResult.userGroupList.length; i++) {
          for (let key in this.userAreaResult.userGroupList[i]) {
            if (
              key !== "checked" &&
              typeof this.userAreaResult.userGroupList[i][key] == "boolean"
            ) {
              if (this.userAreaResult.userGroupList[i][key]) {
                this.userAreaResult.userGroupList[i].checked = true;
              } else {
                this.userAreaResult.userGroupList[i].checked = false;
                break;
              }
            }
          }
        }
        this.userAreaResult.userGroupList = this.userAreaResult.userGroupList.concat(
          []
        );
        this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
      } else {
        this.tenantRelatedAreaList[index - 1].colCheck = false;
        this.userAreaResult.userGroupList.map((item) => {
          for (let key in item) {
            if (key == objs) {
              item[key] = false;
              item.checked = false;
            }
          }
        });
        this.userAreaResult.userGroupList = this.userAreaResult.userGroupList.concat(
          []
        );
        this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
      }
    },

    select(obj, index) {
      const objs = this.tenantRelatedAreaList[index - 1].prop;
      if (obj) {
        this.tenantRelatedAreaList[index - 1].colCheck = true;
        this.userAreaResult.accountList.map((item) => {
          for (let key in item) {
            if (key == objs) {
              item[key] = true;
            }
          }
        });
        for (let i = 0; i < this.userAreaResult.accountList.length; i++) {
          for (let key in this.userAreaResult.accountList[i]) {
            if (
              key !== "checked" &&
              typeof this.userAreaResult.accountList[i][key] == "boolean"
            ) {
              if (this.userAreaResult.accountList[i][key]) {
                this.userAreaResult.accountList[i].checked = true;
              } else {
                this.userAreaResult.accountList[i].checked = false;
                break;
              }
            }
          }
        }
        this.userAreaResult.accountList = this.userAreaResult.accountList.concat(
          []
        );
        this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
      } else {
        this.tenantRelatedAreaList[index - 1].colCheck = false;
        this.userAreaResult.accountList.map((item) => {
          for (let key in item) {
            if (key == objs) {
              item[key] = false;
              item.checked = false;
            }
          }
        });
        this.userAreaResult.accountList = this.userAreaResult.accountList.concat(
          []
        );
        this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
      }
    },
    // テーブル行の全選択イベント
    rowChange(row, index) {
      let item = this.userAreaResult.accountList[index];
      let arr = [];
      // let isCheckRow = false;
      if (item.checked) {
        for (let key in item) {
          if (typeof item[key] == "boolean") {
            item[key] = true;
          }
        }
        for (let i = 0; i < this.userAreaResult.accountList.length; i++) {
          for (let key in this.userAreaResult.accountList[i]) {
            if (
              key !== "checked" &&
              typeof this.userAreaResult.accountList[i][key] == "boolean"
            ) {
              if (this.userAreaResult.accountList[i][key]) {
                arr.push(key);
              }
            }
          }
        }
        let returnArr = this.filtetArray(arr);
        this.tenantRelatedAreaList.map((item) => {
          returnArr.map((items) => {
            if (item.prop == items) {
              item.colCheck = true;
            }
          });
        });
        this.userAreaResult.accountList = this.userAreaResult.accountList.concat(
          []
        );
        this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
      } else {
        arr = [];
        for (let key in item) {
          if (typeof item[key] == "boolean") {
            item[key] = false;
            this.tenantRelatedAreaList.map((item) => {
              if (key == item.prop) item.colCheck = false;
            });
          }
        }
        this.userAreaResult.accountList = this.userAreaResult.accountList.concat(
          []
        );
        this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
      }
    },
    cellChangeUserGroup(obj, index) {
      let isCheck = false;
      let isCheckRow = false;
      let ele = this.userAreaResult.userGroupList[index];
      if (ele[obj]) {
        ele[obj] = true;
        this.userAreaResult.userGroupList = this.userAreaResult.userGroupList.concat(
          []
        );
        for (let key in ele) {
          if (key !== "checked") {
            if (ele[key]) {
              isCheckRow = true;
            } else {
              isCheckRow = false;
              break;
            }
          }
        }
        if (isCheckRow) {
          ele.checked = true;
        }
        for (let i = 0; i < this.userAreaResult.userGroupList.length; i++) {
          if (this.userAreaResult.userGroupList[i][obj]) {
            isCheck = true;
          } else {
            isCheck = false;
            break;
          }
        }
        if (isCheck) {
          this.tenantRelatedAreaList.map((item) => {
            if (item.prop == obj) {
              item.colCheck = true;
            }
          });
          this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
        } else {
          this.tenantRelatedAreaList.map((item) => {
            if (item.prop == obj) {
              item.colCheck = false;
            }
          });
          this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
        }
      } else {
        ele[obj] = false;
        ele.checked = false;
        this.userAreaResult.userGroupList.map((items) => {
          if (items[obj] == true) {
            isCheck = true;
          } else {
            isCheck = false;
          }
        });
        this.tenantRelatedAreaList.map((item) => {
          if (item.prop == obj) {
            item.colCheck = false;
          }
        });
        this.userAreaResult.userGroupList = this.userAreaResult.userGroupList.concat(
          []
        );
        this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
      }
    },
    // 各セルの選択イベント
    cellChange(obj, index) {
      // console.log(obj, index, col);
      let isCheck = false;
      let isCheckRow = false;
      let ele = this.userAreaResult.accountList[index];
      if (ele[obj]) {
        ele[obj] = true;
        this.userAreaResult.accountList = this.userAreaResult.accountList.concat(
          []
        );
        for (let key in ele) {
          if (key !== "checked") {
            if (ele[key]) {
              isCheckRow = true;
            } else {
              isCheckRow = false;
              break;
            }
          }
        }
        if (isCheckRow) {
          ele.checked = true;
        }
        for (let i = 0; i < this.userAreaResult.accountList.length; i++) {
          if (this.userAreaResult.accountList[i][obj]) {
            isCheck = true;
          } else {
            isCheck = false;
            break;
          }
        }
        if (isCheck) {
          this.tenantRelatedAreaList.map((item) => {
            if (item.prop == obj) {
              item.colCheck = true;
            }
          });
          this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
        } else {
          this.tenantRelatedAreaList.map((item) => {
            if (item.prop == obj) {
              item.colCheck = false;
            }
          });
          this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
        }
      } else {
        ele[obj] = false;
        ele.checked = false;
        this.userAreaResult.accountList.map((items) => {
          if (items[obj] == true) {
            isCheck = true;
          } else {
            isCheck = false;
          }
        });
        this.tenantRelatedAreaList.map((item) => {
          if (item.prop == obj) {
            item.colCheck = false;
          }
        });
        this.userAreaResult.accountList = this.userAreaResult.accountList.concat(
          []
        );
        this.tenantRelatedAreaList = this.tenantRelatedAreaList.concat([]);
      }
    },
    filtetArray(arr) {
      arr.sort();
      var newArrList = [];
      for (var i = 0; i < arr.length; i++) {
        var temp = arr[i];
        var qty = 0;
        for (var j = 0; j < arr.length; j++) {
          if (arr[j] == temp) {
            qty++;
            arr[j] = -1;
          }
        }
        if (temp != -1) {
          if (qty == this.userAreaResult.accountList.length) {
            newArrList.push(temp);
          }
        }
      }
      return newArrList;
    },

    AccountAreaRelationUpdate(accountList ,userGroupList) {
      this.centerDialogVisibleIsShow = false
      this.showLoading = true
      SystemManageApi.AccountAreaRelationUpdate({ accountList })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          this.showLoading = false
          return;
        }
        this.userGroupAreaRelationUpdate(userGroupList)
      })
    },

    userGroupAreaRelationUpdate(userGroupList) {
      SystemManageApi.UserGroupAreaRelationUpdate({ userGroupList })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          this.showLoading = false
          return;
        }
        this.$messageIotSuccess(this.$t("message.common.saveSuccess", {
          field: this.$t("label.popup.system.userArea.userArea")
        }));
        this.linkTenantDetail()
      }).finally(()=>{
        this.showLoading = false
      });
    },

    //表示テーブルに動画をロードする
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#search-result",
          background: "#ebebe6"
        });
      }
    },
    //隠しフォームロードアニメーション
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },

    linkTenantDetail() {
      this.$router.push({
        name: "system-tenant-detail",
        params: {
          tenantId: this.tenantId
        },
      });
    },
    saveUserArea() {
      this.centerDialogVisibleIsShow = true
    },
    isPassParam(param){
      if(param){
        this.userAreaResult.accountList.map((item) => {
        item.relatedAreaIds = [];
        for (let key in item) {
          if (item[key] == true && key !== "checked") {
            item.relatedAreaIds.push(key);
          }
        }
      });
      this.userAreaResult.userGroupList.map((item) => {
        item.relatedAreaIds = [];
        for (let key in item) {
          if (item[key] == true && key !== "checked") {
            item.relatedAreaIds.push(key);
          }
        }
      });

      let userGroupList = []
      this.userAreaResult.userGroupList.map((item) => {
        userGroupList.push({
          userGroupId: item.userGroupId,
          relatedAreaIds: item.relatedAreaIds,
        });
      });

      let accountList = [];
      this.userAreaResult.accountList.map((item) => {
        accountList.push({
          id: item.id,
          relatedAreaIds: item.relatedAreaIds,
        });
      });
      this.AccountAreaRelationUpdate(accountList ,userGroupList);
      }
    },

    getTableWidths() {
      if(this.$refs.table1.$el.clientWidth != 0) {
        this.tableWidth = this.$refs.table1.$el.clientWidth
      }else {
        this.tableWidth = this.$refs.table2.$el.clientWidth
      }
    },
  },
  mounted() {
    this.tenantId = this.$route.query.tenantId;
    this.tenantName = this.$route.query.tenantName;
    this.tenantExId = this.$route.query.tenantExId;
    this.searchAccountAreaRelation();
    if(this.$refs.table1.$el.clientWidth != 0) {
      this.tableWidth = this.$refs.table1.$el.clientWidth
    }else {
      this.tableWidth = this.$refs.table2.$el.clientWidth
    }
    window.addEventListener('resize', this.getTableWidths, false)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getTableWidths, false)
    if (this.timer) {
      clearInterval(this.timer);
    }
  },

  created() {
    this.$authCheck("010606")
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/tenants/search",
        title: "label.router.Thetenant",
      },
      {
        path: "",
        title: "label.router.tenantDetail",
      },
      {
        path: "",
        title: "label.router.Userareaediting",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);

  },
};
</script>

<style scoped lang="scss">
::v-deep .body {
  overflow-x: hidden;
}
::v-deep .margin-right-2 .el-button--small {
  width: 86px;
}

.title {
  width: 200px;
  text-align: left;
  margin-bottom: 10px;
}
.display {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.color {
  color: #525250;
  font-size: 16px;
}
::v-deep .el-form-item {
  margin-bottom: 0 !important;
  padding-left: 20px;
}

::v-deep .el-table .cell{
  font-size: 12px;
  padding: 0px !important;
  white-space: pre-line;
}
::v-deep .el-table td{
  height: 52px !important;
  padding: 0px !important;
}
::v-deep .el-table tr{
  height: 0px !important;
  padding: 0px !important;
}
::v-deep .el-table th, .el-table td {
  padding: 0px !important;
}
::v-deep .table-account-list>  .el-table__body-wrapper{
    display: none;
}
.table-account-list::v-deep {
  .el-table__header {
    border-bottom: 0px !important
  }
}

.table-account-list {
  height: 40px !important;
}

::v-deep .el-checkbox__inner {
  margin-left: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.tenant {
  float: left;
  margin-left: 100px;
}
.tenant-title {
  float: left;
  width: 100px;
}
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}

/* No.135 */
::v-deep .body .m-top-5{
  margin-top: 60px !important;
}
::v-deep .el-table .el-table__header th .cell {
  margin-bottom: 8px;
}

::v-deep .el-scrollbar__wrap {
  display: flex;
}

::v-deep .el-table-one {
  display: none !important;
}

.scrollbar-outside {
  display: flex;
}

.allChoice-type {
  height: 40px;
  line-height: 40px;
}

::v-deep .el-table td {
  height: 70px !important;
  background-color: #F2F2ED;
}

::v-deep .el-table th {
  min-height: 45px !important;
}

.fullname-type {
  min-height: 26px;
  width: 200px;
  display: flex;
  align-items: center;
}

.fullname-type-noData {
  width: 1540px;
}

::v-deep .el-table__header {
  width: 200px !important;
}

.no-data{
  width: 100%;
  text-align: center;
  color: #909399;
}
.editorialObject-type {
  margin-right: 68px;
  font-size: 16px;
  color: #525250;
}
::v-deep .el-table-two {
  padding: 20px !important;
}

::v-deep .table-account-list {
  .el-table__header-wrapper {
    table {
      colgroup {
        display: none !important;
      }
    }
  }
}

::v-deep .table-type-user-area-edit .el-table__body-wrapper {
  overflow: auto !important;
  height: 359px !important;
}

::v-deep .el-table--border th {
  border-bottom:0px !important;
  border-right: 0px !important;
}

::v-deep  .el-table--border td {
  border-right: 0px !important;
}

::v-deep .el-table thead.is-group th {
  background: #F2F2ED !important;
}

::v-deep .el-table th.is-center, .el-table td.is-center {
  text-align: center !important;
}

::v-deep .el-table__fixed::before, .el-table__fixed-right::before {
  display: none !important;
}

::v-deep .el-table--group, .el-table--border {
  border: 0px !important;
}

::v-deep .el-table__body .el-table__row.hover-row td{
  background-color: #F2F2ED;
}

::v-deep .el-table__fixed {
  height: auto !important;
  bottom: 18px;
  box-shadow: none !important
}

::v-deep .el-table th.gutter{
  display: table-cell!important;
}

::v-deep .el-table__fixed-body-wrapper {
  z-index: 1 !important;
}

::v-deep .radio-type {
  margin-bottom: 28px;
  .el-radio {
    margin-right: 46px !important;
  }
  .el-radio__label {
    font-size: 16px !important;
  }
}

.table-type ::v-deep {
  min-width: 841px;
  width: 100%;
  .el-table__empty-block {
    width: auto !important;
  }
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  opacity: 1 !important;
  background: #F2F2ED !important;
}

::v-deep .el-table thead.is-group th:nth-child(1){
  position: sticky;left:0px;z-index: 99
}
</style>
